import React, { useState } from "react";
import styled from "styled-components";
import UnallocatedOvertime from "./UnallocatedOvertime";
import ShiftProfitability from "../ShiftProfitability/ShiftProfitability";

const DashboardReports = () => {
  const [activeTab, setActiveTab] = useState<"overtime" | "profitability">("overtime");

  return (
    <Wrapper>
      <TabsContainer>
        <Tab
          isActive={activeTab === "overtime"}
          onClick={() => setActiveTab("overtime")}
        >
          Unallocated Overtime
        </Tab>
        <Tab
          isActive={activeTab === "profitability"}
          onClick={() => setActiveTab("profitability")}
        >
          Shift Profitability
        </Tab>
      </TabsContainer>

      <ContentWrapper>
        {activeTab === "overtime" && <UnallocatedOvertime />}
        {activeTab === "profitability" && <ShiftProfitability />}
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const TabsContainer = styled.div`
  display: flex;
  gap: 0;
  border-bottom: 2px solid #0a9688;
  margin: 20px 40px 0 40px;
`;

const Tab = styled.button<{ isActive: boolean }>`
  padding: 12px 24px;
  border: none;
  background-color: ${(props) => (props.isActive ? "#0a9688" : "#e0e0e0")};
  color: ${(props) => (props.isActive ? "white" : "#333")};
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 8px 8px 0 0;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${(props) => (props.isActive ? "#0a9688" : "#ccc")};
  }
`;

const ContentWrapper = styled.div`
  width: 100%;
`;

export default DashboardReports;
